// Croqui: `components/TxStatus.tsx`. Os 6 status de `spec/05-transactions.md` §4.3 em
// pt-BR, com o tom do `Pill`. O mapa é do kit porque seller e admin mostram o mesmo.

import type { Tone } from './ink.ts';
import { Pill } from './pill.tsx';

export const TRANSACTION_STATUSES = [
  'pending',
  'paid',
  'expired',
  'failed',
  'refunded',
  'chargeback',
] as const;

export type TransactionStatus = (typeof TRANSACTION_STATUSES)[number];

export const TX_STATUS: Record<TransactionStatus, { tone: Tone; label: string }> = {
  pending: { tone: 'wait', label: 'Aguardando' },
  paid: { tone: 'ok', label: 'Pago' },
  // Feminino: o sujeito na tela é "a cobrança", não "o pagamento".
  expired: { tone: 'neutral', label: 'Expirada' },
  failed: { tone: 'bad', label: 'Falhou' },
  refunded: { tone: 'neutral', label: 'Estornada' },
  chargeback: { tone: 'bad', label: 'Chargeback' },
};

export function isTransactionStatus(value: unknown): value is TransactionStatus {
  return TRANSACTION_STATUSES.some((status) => status === value);
}

/**
 * `status` chega como `string` do OpenAPI (a API não fecha o enum na resposta): status
 * desconhecido mostra o valor cru em tom neutro em vez de sumir da tela.
 */
export function statusPill(status: string): { tone: Tone; label: string } {
  return isTransactionStatus(status) ? TX_STATUS[status] : { tone: 'neutral', label: status };
}

/** Pill de status de transação com rótulo pt-BR. */
export function TxStatusPill({ status }: { status: string }) {
  const { tone, label } = statusPill(status);
  return <Pill tone={tone}>{label}</Pill>;
}
